import { animated, useTransition } from "@react-spring/web"
import { useEffect, useRef } from "react"
import { useLocation, useOutlet } from "react-router-dom"

export const PageOutlet = () => {
    const outlet = useOutlet()
    const location = useLocation()
    const ref = useRef<HTMLDivElement>(null)

    const transitions = useTransition(outlet, {
        keys: location.pathname,
        from: { 
            opacity: 0,
            transform: 'translateX(32px)',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        },
        enter: { 
            opacity: 1,
            transform: 'translateX(0px)',
            position: 'relative',
            flex: 1,
            display: "flex",
            flexDirection: "column"
        },
        leave: { 
            opacity: 0,
            transform: 'translateX(-32px)',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            pointerEvents: 'none'
        },
        config: { 
            mass: 1,
            tension: 200,
            friction: 30
        }
    })

    useEffect(() => {
        ref.current.scrollTo({
            top: 0,
            behavior: 'smooth'            
        })
    }, [location])

    return (
        <div ref={ref} id="page_content">
            {transitions((style, outlet) => (
                <animated.div style={style}>
                    {outlet}
                </animated.div>
            ))}
        </div>
    )
}